import { useEffect, useState } from 'react'
import { fetchBootstrapHint, login, type AuthUser } from '@/api/auth'
import { Button } from '@/components/ui/Button'

interface Props {
  onLoggedIn: (user: AuthUser) => void
}

export function LoginPanel({ onLoggedIn }: Props) {
  const [email, setEmail] = useState('admin@localhost')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const [hint, setHint] = useState('')

  useEffect(() => {
    void fetchBootstrapHint()
      .then((h) => {
        if (h.defaultEmail) setEmail(h.defaultEmail)
        setHint(h.hint || '')
      })
      .catch(() => undefined)
  }, [])

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError('')
    try {
      const res = await login(email, password)
      onLoggedIn(res.user)
    } catch (err) {
      setError(String((err as Error).message || err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="shell" style={{ maxWidth: 420, margin: '12vh auto' }}>
      <div className="panel-soft" style={{ padding: 24 }}>
        <div className="brand" style={{ marginBottom: 16 }}>
          <div className="brand-mark">
            Flow<em>line</em>
          </div>
          <div className="brand-sub">Sign in to your workspace</div>
        </div>
        <form onSubmit={submit}>
          <label className="mono" style={{ display: 'block', marginBottom: 8 }}>
            Email
            <input
              className="select"
              style={{ display: 'block', width: '100%', marginTop: 4 }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
            />
          </label>
          <label className="mono" style={{ display: 'block', marginBottom: 12 }}>
            Password
            <input
              className="select"
              type="password"
              style={{ display: 'block', width: '100%', marginTop: 4 }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </label>
          {error && (
            <div className="mono" style={{ color: 'var(--danger, #c44)', marginBottom: 10 }}>
              {error}
            </div>
          )}
          <Button type="submit" variant="primary" disabled={busy} style={{ width: '100%' }}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
        {hint && (
          <p className="row-meta" style={{ marginTop: 14 }}>
            {hint}
          </p>
        )}
      </div>
    </div>
  )
}
